import { post } from '../../utils/http';

export const clientSendBookedEmployees = ({ accountId, branchId, projectId, adminIds, sendCopy }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/clients/bookedEmployees/send`, {
    adminIds,
    sendCopy
  });

export const clientTimesheetSendProject = ({ accountId, branchId, projectId, adminIds, sendCopy }) =>
  post(`/accounts/${accountId}/branches/${branchId}/projects/${projectId}/clients/timesheet/send`, {
    adminIds,
    sendCopy
  });
